import { Maybe } from '@mxt/zio/codec'
import { form2 } from '@pulseops/common'
import { pipe } from 'fp-ts/function'
import i18next from 'i18next'
import * as t from 'io-ts'
import { withMessage } from 'io-ts-types'

export namespace WriteOffSubmissionForm {
  export const File = t.type({
    fileName: t.string,
    fileExtension: t.string,
    size: t.number,
    base64: t.string,
    uploadedDate: form2.date.required,
    file: form2.file.required
  })

  export type File = t.TypeOf<typeof File>

  export type FileListBrand = {
    readonly FileList: unique symbol
  }
  export type FileList = t.Branded<File[], FileListBrand>

  export const withFileRequired = () =>
    pipe(
      t.array(File),
      form2.refine(
        (l): l is FileList => l.length > 0,
        (l) => i18next.t('error_required_field', { ns: 'form' }),
        'FileList'
      )
    )

  export const WriteOffSubmission = t.type({
    paymentReason: withMessage(form2.selectOption.required, () =>
      i18next.t('message:MS020009', { field: i18next.t('submission:PaymentReason') })
    ),
    remark: withMessage(form2.string.required, () =>
      i18next.t('message:MS020009', { field: i18next.t('submission:Remark') })
    ),
    attachments: withFileRequired(),
    transactionType: t.string
  })

  export const codec = WriteOffSubmission

  export type Validated = t.TypeOf<typeof codec>

  export type Raw = t.OutputOf<typeof codec>
}
